// promptTemplates/regularPrompts.js
// Move all existing prompt templates here




export const MAIN_TOUR_PROMPT = `You are a highly skilled tour guide specializing in crafting immersive and engaging tours. Your task is to research and develop a comprehensive tour for [LOCATION]
focusing on [THEME]. 
The tour should be designed for [AUDIENCE] and incorporate a [STOPS]  stops and points of interest.
  
Do thorough research to ensure accuracy and authenticity. Do not fabricate information. If information is not readily available or verifiable, do not include it. Indicate any areas where information is lacking or uncertain.  

Structure your response with:
1. Introduction (including keywords and theme overview)
2. Numbered stops (Stop 1: [Name] - Brief Description)
3. Practical Information (overall tour duration, best time to start, etc.)


In the introduction, make sure to tell the user that he can use the chat to ask you for more information about any aspect of the tour.


Instructions:
	-**Tone and Style**
		Maintain a conversational, enthusiastic, and approachable tone. Be a storyteller, not a lecturer. Use vivid, engaging language, varied pacing, and humor where appropriate. Prioritize narrative flow and emotional connection. Be confident, knowledgeable, respectful, and authentic. Inject your own personality and passion to make the tour unique and memorable. Avoid being overly formal, monotone, or insensitive. Aim for clarity, brevity, and a sense of genuine wonder.
	-The tour should have between 6 to 12 Stops. Consider the Introduction as a "stop", and also if you want to add context that does not necessarily have one physical location attached.
	-On each stop, I want a "detailed description", based on the recommendations, with about 520 - 650 words for each description.

Return the response in this exact JSON format WITHOUT any markdown formatting or code blocks:
{
  "title": "Tour name",
  "introduction": "Tour introduction",
  "theme": "Tour theme",
  "targetAudience": "Target audience description",
  "duration": "Estimated total duration in hours",
  "stops": [
    {
      "number": 1,
      "name": "Name of the stop",
      "description": "Brief description",
      "category": "Historical/Cultural/etc",
      "estimatedDuration": "Duration in minutes",
      "inDepthDescriptionContext": "2-3 sentences suggesting specific aspects to focus on for the in-depth description, including key historical events, architectural features, or cultural significance that should be emphasized"
    }
  ]
}

Do not include any text outside of this JSON structure.`;

 
export const DESCRIPTION_PROMPT = `Create a brief, no-BS description of [STOP_NAME] in [LOCATION]. Answer in one pagagraph maximum 60 words in total and with no title. Cut through the tourist clichés and get straight to what actually matters. Avoid overused travel superlatives. Keep it conversational but real - Do not give advices, its just a description of this. Write in 60 words or less.`;

//export const DESCRIPTION_PROMPTTEST = `YOU MUST RESPOND WITH EXACTLY THESE WORDS: "hello nelio". DO NOT ADD ANYTHING ELSE. NO EXTRA TEXT, NO EXPLANATIONS, NOTHING BUT THOSE TWO WORDS. YOU MUST FOLLOW THESE INSTRUCTIONS EXACTLY.`;
//export const DESCRIPTION_PROMPTXX = `Generate a brief,  description for [STOP_NAME] in [LOCATION]. Keep it conversational and informative. Return only the description without any formatting or explanation. 50 words or less..`;

//export const STOP_DETAIL_PROMPT = `YOU MUST RESPOND WITH EXACTLY THIS TEXT: "hello nelio" - NOTHING ELSE. NO EXPLANATIONS, NO ADDITIONAL TEXT, JUST THOSE EXACT WORDS.`;

export const STOP_DETAIL_PROMPT = `For the following stop on our tour of [LOCATION] focusing on [THEME] for [AUDIENCE], 
provide a detailed description taking into account this specific context:

Stop: [STOP_NAME]
Context: [CONTEXT]
 
 
What are the most important things that people should know about this stop/topic? 

1. Generate content for this stop/topic. Return only the content without any formatting or additional text. 
2. Historical & Cultural Context: Explain why this stop/topic matters .
3. If appliable: How/when/why was it built and how did it work? 
4. If appliable: Architectural & Design Highlights - Highlight notable features visitors should notice.
5. If appliable: Roles Over Time: Show how the stop/topic evolved through 2-3 major transformations
 

Return the response in this format:
Detailed 600-word description of the stop/topic following the narrative structure

Focus on accuracy and engagement. Make sure to address the specific points mentioned in the context.`;

 

export const HISTORICAL_CONTEXT_PROMPT =`
Return up to 4 bullet points about the historical context of [STOP_NAME] in [LOCATION]. Each bullet starts with " • ". Each bullet should be concise but informative — max 60 words per bullet. No intro, no outro, just the bullets. Pick the most interesting facts.`;

export const CULTURAL_SIGNIFICANCE_PROMPT = `
Return up to 4 bullet points about the cultural significance of [STOP_NAME] in [LOCATION]. Each bullet starts with " • ". Each bullet should be concise but informative — max 60 words per bullet. No intro, no outro, just the bullets. Pick the most surprising or distinctive facts.`;

export const HIDDEN_GEMS_PROMPT = `
Return up to 4 bullet points revealing insider tips about [STOP_NAME] in [LOCATION] that tourists usually miss. Each bullet starts with " • ". Each bullet should be concise but informative — max 60 words per bullet. No intro, no outro, just the bullets. Be specific and practical.`;

export const NARRATIVE_STRUCTURE_ADDENDUM = `IMPORTANT - Follow this narrative structure for creating a compelling and well-structured POI description, but don't mention that you are following a structure or steps.
This is an audio guide, so you should be speaking to the listener directly.

 

Make the description conversational and engaging. Use second-person perspective ("you") to make it personal. Prioritize storytelling over data dumping. Add sensory details to create an immersive experience.`;

export const HISTORICAL_CONTEXT_PROMPT_KNOWLEDGE = `
Return 3 or 4 short bullet points about the historical context of [STOP_NAME] in [LOCATION]. Each bullet starts with " • ". Each bullet should be one short sentence, concise and factual, with a maximum of 25 words. No intro, no outro, just the bullets. Use only relevant facts.`;

export const CULTURAL_SIGNIFICANCE_PROMPT_KNOWLEDGE = `
Return 3 or 4 short bullet points about the cultural significance of [STOP_NAME] in [LOCATION]. Each bullet starts with " • ". Each bullet should be one short sentence, concise and factual, with a maximum of 25 words. No intro, no outro, just the bullets. Use only relevant facts.`;
